jQuery(document).ready(function() {
  jQuery('.wc-block-grid__product').each(function() {
    var rowHeight = jQuery(this).outerHeight(true); 
    var containerHeight = jQuery(this).parent().height(); 
    var numRows = Math.round(containerHeight / rowHeight); 
    if (numRows <= 2) {
      jQuery(this).children().css("margin-bottom", "8px"); 
    } else {
      if (jQuery(window).width() <= 768) {
        jQuery(this).children().css("margin-bottom", "48px"); 
      } else {
        jQuery(this).children().css("margin-bottom", "48px");
      }
    }
  });
});